import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-626c2ba2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "titlebar-actions-primary"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Atualizar Status")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = { class: "ui-card-body" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" })
], -1))
const _hoisted_14 = { class: "myDivToPrint" }
const _hoisted_15 = { class: "ant-row ui-pedido-dados-principais" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "N.Pedido:")
], -1))
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Data:")
], -1))
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Valor Total:")
], -1))
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Status:")
], -1))
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Cliente:")
], -1))
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_28 = { class: "ui-fw-600" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_30 = { class: "ant-row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Total Produtos:")
], -1))
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Frete:")
], -1))
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Acréscimo:")
], -1))
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Desconto:")
], -1))
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_40 = { class: "ant-row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Forma de Entrega:")
], -1))
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Forma de Pagamento:")
], -1))
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_45 = { class: "ant-row" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Endereço de Entrega:")
], -1))
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_48 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Destinatário:")
], -1))
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-pedido-dados-principais ui-mt-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600 ui-daj-center" }, "PACOTES PARA ENTREGA")
  ])
], -1))
const _hoisted_52 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_53 = { class: "ui-fw-600" }
const _hoisted_54 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Produtos:", -1))
const _hoisted_58 = { class: "ant-row" }
const _hoisted_59 = { class: "ui-fw-600" }
const _hoisted_60 = {
  key: 2,
  class: "ant-row"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ui-fw-600" }, "Observações:")
], -1))
const _hoisted_62 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_64 = { class: "ui-table" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-14 ui-cell ui-fw-600" }, " Produto "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-5 ui-cell ui-ta-right ui-fw-600" }, " Quantidade "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-5 ui-cell ui-ta-right ui-fw-600" }, " Valor Total ")
], -1))
const _hoisted_66 = { class: "ui-rows" }
const _hoisted_67 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-14 ui-cell ui-ellipsis",
  "data-title": "Produto"
}
const _hoisted_68 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-5 ui-cell ui-ta-right",
  "data-title": "Quantidade"
}
const _hoisted_69 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-5 ui-cell ui-ta-right",
  "data-title": "Valor Total"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Cancelar")
], -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Confirmar")
], -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = { class: "ant-row" }
const _hoisted_75 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_76 = { class: "ant-row" }
const _hoisted_77 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_combo_status_pedido = _resolveComponent("combo-status-pedido")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, "Pedido: " + _toDisplayString(_ctx.state.pedido.numeroIdentificacao), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        ((_ctx.state.pedido.status !== _ctx.EStatusPedido.Cancelado))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "ui-button -primary",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.apresentarModalStatus = true))
              }, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.state.pedido.numeroIdentificacao), 1),
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(_ctx.state.pedido.data)), 1),
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, " R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.pedido.valorTotal)), 1),
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.obterDescricaoStatus(_ctx.state.pedido.status)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.state.pedido.nomeRazaoSocial), 1),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.obterLabelCpfCnpj()) + ":", 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(_ctx.state.pedido.cpfCnpj)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, " R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.totalProdutos())), 1),
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, " R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.pedido.valorFrete)), 1),
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, " R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.pedido.valorAcrescimos)), 1),
                    _hoisted_37,
                    _createElementVNode("div", _hoisted_38, " R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.pedido.valorDesconto)), 1)
                  ]),
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.state.pedido.detalhesFormaEntrega), 1),
                    _hoisted_43,
                    _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.state.pedido.detalhesFormaPagamento), 1)
                  ]),
                  (_ctx.apresentarEnderecoEntrega())
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.apresentacaoEndereco()), 1)
                        ]),
                        (_ctx.state.pedido.entrega.destinatario)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                              _hoisted_49,
                              _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.state.pedido.entrega.destinatario), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.UtilitarioGeral.validaLista(_ctx.state.pacotes))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_51,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.pacotes, (pacote, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "ant-row",
                            key: 'PED-PACOTE-' + index
                          }, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("span", _hoisted_53, "PACOTE " + _toDisplayString((index + 1)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("span", {
                                style: {"display":"inline-flex","gap":"25px"},
                                innerHTML: _ctx.apresentacaoPacote(pacote)
                              }, null, 8, _hoisted_55)
                            ]),
                            ((_ctx.state.pacotes.length > 1))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                  _hoisted_57,
                                  _createElementVNode("div", _hoisted_58, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pacote.produtos, (produto) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "ant-col ant-col-xs-24 ant-col-xl-24",
                                        key: 'PED-PACOTE-' + index + '-PROD-' + produto.sku
                                      }, [
                                        _createElementVNode("span", _hoisted_59, _toDisplayString(produto.sku), 1),
                                        _createTextVNode(" " + _toDisplayString(produto.produto) + " - Quantidade: " + _toDisplayString(produto.quantidade), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.state.pedido.observacoes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _hoisted_61,
                        _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.state.pedido.observacoes), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_63,
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createElementVNode("div", _hoisted_66, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.pedido.itens, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.codigo,
                          class: "ant-row ui-row"
                        }, [
                          _createElementVNode("div", _hoisted_67, " SKU: " + _toDisplayString(item.sku) + " - " + _toDisplayString(item.produto), 1),
                          _createElementVNode("div", _hoisted_68, _toDisplayString(item.quantidade), 1),
                          _createElementVNode("div", _hoisted_69, " R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(item.valorTotal)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      keyboard: false,
      title: "Atualizar status do Pedido",
      centered: "",
      width: 600,
      visible: _ctx.state.apresentarModalStatus,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.apresentarModalStatus) = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "ui-button -second",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.apresentarModalStatus = false))
          }, _hoisted_71),
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.atualizarStatusPedido()))
          }, _hoisted_73)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createVNode(_component_a_form_item, { label: "Novo Status do Pedido" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_combo_status_pedido, {
                      valor: _ctx.state.historico.status,
                      "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.historico.status) = $event)),
                      omitir: _ctx.state.pedido.status
                    }, null, 8, ["valor", "omitir"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createVNode(_component_a_form_item, { label: "Detalhes" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      value: _ctx.state.historico.detalhes,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.historico.detalhes) = $event)),
                      placeholder: "Digite qualquer informação que você achar importante para o cliente."
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}